module.exports = __webpack_public_path__ + "images/ui-bg_diagonals-thick_20_666666_40x40.png";